"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const card_1 = require("../../molecules/card");
const card_row_divided_1 = require("../../atoms/card-row-divided");
const typography_1 = require("../../shared/typography");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const joinFoodPreferences = (allergies) => {
    let allergiesString = "";
    allergies.forEach((pref) => {
        allergiesString += pref.name + ", ";
    });
    if (allergiesString.length > 1) {
        allergiesString = allergiesString.slice(0, -2);
    }
    else {
        allergiesString = "-";
    }
    return allergiesString;
};
const checkBreastFeeding = (foodPreferences, translations) => {
    const isBreastFeeding = (foodPreferences && foodPreferences.isBreastFeeding) || false;
    return isBreastFeeding ? translations.yes : translations.no;
};
exports.default = ({ foodPreferences }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const foodTranslations = t("memberDetailsTranslations.foodPreferences", {
        returnObjects: true
    });
    const codesTranslations = t("memberDetailsTranslations.codes", {
        returnObjects: true
    });
    return ((0, jsx_runtime_1.jsxs)(Card, { header: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: foodTranslations.columnTitle }, void 0), children: [(0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: foodTranslations.allergies, right: joinFoodPreferences(foodPreferences && foodPreferences.allergies) }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: foodTranslations.breastFeeding, right: checkBreastFeeding(foodPreferences, codesTranslations) }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: foodTranslations.customAllergies, right: foodPreferences.customAllergies || "-" }, void 0)] }, void 0));
};
const Card = (0, styled_components_1.default)(card_1.Card) `
  * {
    align-self: flex-start;
  }
`;
//# sourceMappingURL=Nutrition.js.map